import profileGeneral from '@/store/modules/profile/general';

export default {
  profileGeneral,
};
